import AssetGroup from "./AssetGroup";

export default AssetGroup;